import styles from '../../styles/style.module.scss';
import map from '../../../../assets/images/map.png';
import people from '../../../../assets/images/people.png';

import { useRemoteConfig } from 'core/hooks/use-remote-config';
import getLocale from 'src/localization/get-locale';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import { t } from '@web-solutions/module-localization';
import { StarIcon } from 'src/onboarding/assets/icons/StarIcon';

export const UsersTrustComponent = () => {
  const { usersTrust } = useRemoteConfig();
  const locale = getLocale();
  return (
    <>
      <div className={styles.usersTrust}>
        <img src={map} alt='map' />

        <div className={styles.usersTrustTitle}>
          <img src={people} alt='people' />

          <Typography variant='h1-bold'>{usersTrust.title[locale]}</Typography>
        </div>
        <div className={styles.usersTrustReview}>
          <div className={styles.reviewTitle}>
            <div className={styles.rate}>
              {Array.from({ length: 5 }, (_, i) => (
                <StarIcon key={i} />
              ))}
            </div>

            <Typography variant='body-semibold'>{usersTrust.reviewTitle[locale]}</Typography>
          </div>

          <Typography variant='callout-medium' className={styles.reviewDesc}>
            {usersTrust.reviewDescription[locale]}
          </Typography>

          <Typography variant='caption-tabBar' className={styles.reviewDesc}>
            {t('onboarding.voeryPersonalPlan.usersTrust.reviewUser')} 🇩🇪
          </Typography>
        </div>
      </div>
    </>
  );
};
